export default "__VITE_ASSET__D9ou4ol$__"